export default "/assets/images/uk-union-jack-lg.webp?4f3859fb41431daaf3324460f910c5c6";